DO.Subscribe('app:ready', (e, $) => {
  if (window.NodeList && !NodeList.prototype.map) {
    NodeList.prototype.map = Array.prototype.map;
  }

  const emblaNodes = document.querySelectorAll(
    '.imagelist .carousel > .embla',
  );
  let embla = null;

  function setCounter(slider) {
    const status = $('.embla__counter > .counter-current > h3.current');
    const total = $('.embla__counter > .counter-total > h3');

    function pad2(number) {
      return (number < 10 ? '0' : '') + number;
    }

    slider.on('select', () => {
      total.text(slider.slideNodes().length);
      status.text(slider.selectedScrollSnap() + 1);
    });
  }

  function setCaptionHeight(wrapper) {
    if (wrapper) {
      const captions = wrapper.querySelectorAll('.embla__caption');
      const carouselHeight = wrapper.clientHeight;
      let maxHeight = null;

      if (captions.length > 0) {
        maxHeight = Math.max(
          ...captions.map(item => item.clientHeight),
        );
        wrapper.style.height = `${maxHeight + carouselHeight + 20}px`;

        captions.forEach((item) => {
          item.style.height = `${maxHeight}px`;
        });
      }
    }
  }

  if (emblaNodes) {
    window.addEventListener('resize', () => {
      emblaNodes.forEach((emblaNode) => {
        const slide = emblaNode.querySelector('.embla__slide');

        if (slide) {
          emblaNode.style.height = `${slide.clientHeight}px`;
          setCaptionHeight(emblaNode);
        }
      });
    });

    emblaNodes.forEach((emblaNode) => {
      embla = EmblaCarousel(emblaNode, {
        align: 'center',
        containerSelector: '*',
        slidesToScroll: 1,
        containScroll: false,
        draggable: true,
        dragFree: false,
        loop: true,
        speed: 10,
        startIndex: 0,
        selectedClass: 'is-selected',
        draggableClass: 'is-draggable',
        draggingClass: 'is-dragging',
      });

      emblaNode.querySelectorAll('.embla__arrow').forEach((item) => {
        item.addEventListener('click', (event) => {
          if (
            event.currentTarget.classList.contains(
              'embla__arrow-left',
            )
          ) {
            embla.scrollPrev();
          }
          if (
            event.currentTarget.classList.contains(
              'embla__arrow-right',
            )
          ) {
            embla.scrollNext();
          }
        });
      });

      setCounter(embla);
      setCaptionHeight(emblaNode);
    });
  }
});
